import { useRef, useCallback } from 'react';
import { useUIStore } from '@/stores/uiStore';
import { useSSEQuery } from '@/hooks/useSSEQuery';
import { useSidebarResize } from '@/hooks/useSidebarResize';
import ChatHeader from './ChatHeader';
import ActiveContextBreadcrumb from './ActiveContextBreadcrumb';
import ChatMessages from './ChatMessages';
import ChatInput from './ChatInput';

export default function ChatSidebar() {
  const sidebarOpen = useUIStore((s) => s.sidebarOpen);
  const isMobile = useUIStore((s) => s.isMobile);
  const setFleetPanelOpen = useUIStore((s) => s.setFleetPanelOpen);
  const { sidebarWidth, onMouseDown, resizerRef } = useSidebarResize();
  const { sendQuery } = useSSEQuery();
  const inputRef = useRef<HTMLTextAreaElement>(null!);

  const handleSend = useCallback(
    (text: string) => {
      // Close fleet panel and clear its data before sending a new query
      setFleetPanelOpen(false, []);
      sendQuery(text);
    },
    [sendQuery, setFleetPanelOpen]
  );

  if (!sidebarOpen) return null;

  return (
    <div
      className={`relative bg-bg-secondary border-r border-border-strong flex flex-col z-[1000] flex-shrink-0 ${
        isMobile
          ? 'fixed inset-y-14 left-0 w-[300px] shadow-2xl'
          : ''
      }`}
      style={isMobile ? undefined : { width: sidebarWidth, minWidth: 250, maxWidth: 600 }}
    >
      <ChatHeader />
      <ChatMessages />
      <ChatInput onSend={handleSend} inputRef={inputRef} />

      {/* Resizer handle */}
      {!isMobile && (
        <div
          ref={resizerRef}
          onMouseDown={onMouseDown}
          className="absolute top-0 -right-[3px] w-[6px] bottom-0 cursor-col-resize z-[1001] hover:bg-accent-blue/50 transition-colors"
        />
      )}
    </div>
  );
}
